import IUser from '../api/types/user'

export interface ILoginAction {
  type: 'AUTH_LOGIN'
  jwt: string
  user: IUser
}

/**
 * Reason for a logout forced by the backend (error_code of the API response),
 * shown on the login page. Not set for regular logouts by the user.
 */
export type LogoutReason = 'account_deactivated' | 'account_locked' | 'account_unconfirmed' | 'session_expired'

export interface ILogoutAction {
  type: 'AUTH_LOGOUT'
  reason?: LogoutReason
}

export type AuthActions = ILoginAction | ILogoutAction

export function login(jwt: string, user: IUser): ILoginAction {
  return {
    jwt,
    type: 'AUTH_LOGIN',
    user
  }
}

export function logout(reason?: LogoutReason): ILogoutAction {
  return {
    type: 'AUTH_LOGOUT',
    reason
  }
}
